export default __webpack_public_path__ + "static/media/bolt.3d181b84.svg";